module.exports = __webpack_public_path__ + "static/img/demand.0009ad85.png";